import { render } from "./test.vue?vue&type=template&id=f59154b6&ts=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"

import "./test.vue?vue&type=style&index=0&id=f59154b6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__